<script>
    import Card from '@smui/card';
    import Fab, {Label, Icon} from '@smui/fab';
    import {createEventDispatcher} from 'svelte';
    import ContactFooter from "../contact/ContactFooter.svelte";

    const dispatch = createEventDispatcher();

    function addNew() {
        dispatch('new');
    }

    export let header = "";
</script>
<div class="col-6 col-lg-4">
    <Card>
        <div class="cng-card__primary cng-card__header-with-buttons">
            <div class="mdc-typography--headline5">{header}</div>
            <div>
                <Fab on:click={addNew} class="button-shaped-round"><Icon class="material-icons">add</Icon></Fab>
            </div>
        </div>
        <div class="cng-card__divider"></div>
        <div class="cng-card__secondary">
            <slot/>
        </div>
        <ContactFooter/>
    </Card>
</div>
